import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g transform="translate(2 2)">
      <path
        d="M6,11.25 C8.8994949,11.25 11.25,8.8994949 11.25,6 C11.25,3.10050506 8.8994949,0.75 6,0.75 C3.10050506,0.75 0.75,3.10050506 0.75,6 C0.75,8.8994949 3.10050506,11.25 6,11.25 Z M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z"/>
      <path d="M6,0 C2.6862915,0 0,2.6862915 0,6 C0,9.3137085 2.6862915,12 6,12 L6,0 Z"/>
    </g>
  </svg>
);
